import ErrorIcon from '@mui/icons-material/Error';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { clearHttpError, erroHttpErrorSelector } from '../state';
import DialogFlexSales from './DialogFlexSales';
import { ErrorState, PermissionState } from './Visual';
import { BaseButton } from './base';
import { loginRedirectRequest } from '../config/auth.config';

const AppErrorAlert = () => {
  const error = useSelector(erroHttpErrorSelector);
  const { instance } = useMsal();
  const handleChangeAccount = useCallback(() => {
    localStorage.removeItem('id-token-claims');
    instance.loginRedirect(loginRedirectRequest);
  }, [instance]);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = useCallback(() => dispatch(clearHttpError()), [dispatch]);
  if (!error) return null;

  const code = error?.innerException?.response?.status || error?.code;
  let title = '';
  switch (code) {
    case 504:
      title = t('errors.awsError.timeoutTitle');
      break;
    case 403:
      title = t('errors.permissions.title');
      break;
    case 422:
      title = t('errors.coded.422');
      break;
    default:
      title = t('errors.awsError.title');
  }

  const backendMessage = (error.data as { message?: string })?.message;
  let message = t('errors.awsError.description');
  const isTechnicalTimeout = code === 504;

  if (isTechnicalTimeout) {
    message = t('errors.coded.504');
  } else if (backendMessage) {
    message = backendMessage;
  } else if (i18n.exists(`errors.coded.${code}`)) {
    message = t(`errors.coded.${code}`);
  }
  const stateContent =
    code === 403 ? (
      <PermissionState title={title} description={message} />
    ) : (
      <ErrorState title={title} description={message} />
    );

  return (
    <DialogFlexSales
      open
      onClose={handleClose}
      aria-describedby="alert-dialog-error-description"
      dialogTitle={title}
      subtitle={t('errors.request.subtitle')}
      icon={<ErrorIcon />}
    >
      <DialogContent id="alert-dialog-error-description">{stateContent}</DialogContent>
      <DialogActions>
        {code === 403 && (
          <BaseButton onClick={handleChangeAccount}>
            {t('errors.permissions.changeAccount')}
          </BaseButton>
        )}
        <BaseButton onClick={handleClose}>{t('common.ok')}</BaseButton>
      </DialogActions>
    </DialogFlexSales>
  );
};

export default AppErrorAlert;
